import React, { Component } from 'react';
import { ImagePicker } from 'react-file-picker'

import './css/OpenQuestion.css';
import StringUtils from "../../utils/StringUtils";

class OpenQuestion extends Component {

    componentWillMount() {
        const question = StringUtils.removeImage(this.props.question);
        const questionImage = StringUtils.getLastImage(this.props.question);

        this.setState({
            question: question,
            questionImage: questionImage
        });
    }

    handleTypeChange = () => {
        const multiline = !this.props.multiline;
        this.props.setMultiline(this.props.id, multiline);
    };

    setQuestion = (event) => {
        const question = event.target.value;
        this.setState({ question: question });
        this.props.setQuestion(this.props.id, StringUtils.createTextWithImg(question, this.state.questionImage));
    };

    removeQuestionImage = () => {
        this.setState({ questionImage: null });
        this.props.setQuestion(this.props.id, this.props.question);
    };

    deleteQuestion = () => {
        const userIsSure = window.confirm("Na pewno?");
        if (userIsSure) {
            this.props.deleteQuestion(this.props.id);
        }
    };

    addPoint = () => {
        this.props.setPoints(this.props.id, this.props.points + 1);
    };

    removePoint = () => {
        this.props.setPoints(this.props.id, this.props.points - 1);
    };

    render() {
        const questionImage = (<img alt="external" className="external-image" src={this.state.questionImage} />);

        return (
            <div className="task-block open-question-edit">
                {this.props.isFirst ? '' : <button className="btn-square" onClick={this.props.moveUp}><i className="fas fa-arrow-up"></i></button>}
                {this.props.isLast ? '' : <button className="btn-square" onClick={this.props.moveDown}><i className="fas fa-arrow-down"></i></button>}
                <div className="question-number">Pytanie {this.props.number} ({this.props.points} pkt.
                    <button className="btn-square" onClick={this.addPoint}><i className="fas fa-plus" /></button>
                    <button className="btn-square" onClick={this.removePoint}><i className="fas fa-minus" /></button>
                    )</div>
                <div className="question">
                    <input type="text" placeholder="Pytanie" value={this.state.question} className="question-value" onChange={this.setQuestion} />
                    {this.state.questionImage != null ? questionImage : ''}
                    <ImagePicker
                        extensions={['jpg', 'jpeg', 'png']}
                        dims={{ minWidth: 100, minHeight: 100 }}
                        onChange={base64EncodedString => this.setState({ questionImage: base64EncodedString })}
                        onError={errMsg => console.log(errMsg)}
                        style={{ display: "inline-block" }}
                    >
                        <button className="btn-square"><i className="far fa-image" /></button>
                    </ImagePicker>
                    {this.state.questionImage != null ? <button className="btn-square" onClick={this.removeQuestionImage}><i className="fas fa-ban" /></button> : ''}
                    <button className="btn-square" onClick={this.deleteQuestion}><i className="far fa-trash-alt" /></button>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input type="checkbox" onChange={this.handleTypeChange} checked={this.props.multiline} />
                        <span className="checkmark"/>
                        <label>
                            Odpowiedź w wielu liniach
                        </label>
                    </label>
                </div>
            </div>
        );
    }
}

export default OpenQuestion;